module.exports = __webpack_public_path__ + "img/businessMarketImg.67d2e4ed.png";